import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = async () => {
      // Extract product ID if on product page
      let productId = null;
      let productName = null;
      
      const productMatch = location.pathname.match(/\/product\/(\d+)/);
      if (productMatch) {
        productId = parseInt(productMatch[1]);
        // We'll get the product name from the page title or leave it null
      }

      try {
        await fetch(`${API_URL}/api/analytics/track`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            page: location.pathname,
            product_id: productId,
            product_name: productName
          })
        });
      } catch (error) {
        // Analytics tracking is non-critical, log only in development
        if (process.env.NODE_ENV === 'development') {
          console.warn('Analytics tracking failed:', error);
        }
      }
    };

    trackPageView();
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker;
